<template>
	<div class="z-0 w-full p-6 mb-5 bg-white rounded-lg">
		<slot></slot>
	</div>
</template>
